import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { LOCALES } from 'tests/__mocks__/mockedPrice';
import { NS } from '@/constants';
import { formatLinksDataToColumns } from '@/utils/footerArchiveLinksUtils';
import FooterDynamicLinks from '../../layout/footer/FooterDynamicLinks';
import styles from './FooterArchiveDynamicLinks.module.scss';

const FooterArchiveDynamicLinks = ({ archiveLinkList, locale = 'fr-FR', isMobile = false }) => {
	const { t } = useTranslation(NS.BLOG);
	const linksColumn = formatLinksDataToColumns(t, archiveLinkList, locale);
	return archiveLinkList?.length > 0 ? (
		<>
			{linksColumn.map(({ title, archiveLinkColumn }, index) => (
				<FooterDynamicLinks
					key={index}
					linkColumn={archiveLinkColumn}
					title={title}
					className={styles}
					field="archiveFooterLinks"
					isMobile={isMobile}
				/>
			))}
		</>
	) : null;
};

FooterArchiveDynamicLinks.propTypes = {
	isMobile: PropTypes.bool,
	archiveLinkList: PropTypes.arrayOf(PropTypes.string),
	locale: PropTypes.oneOf(Object.values(LOCALES['-'])),
};

export default FooterArchiveDynamicLinks;
